import { withErrorBoundary } from 'shared'
import { InfoNavbar } from 'layout'

const Information = () => {
  return <div className="information-page"> <InfoNavbar /> </div>
}

export default withErrorBoundary(Information)
